import React, { useState, useEffect } from "react";
import axios from "axios";
import "./SetPassword.css"; // Reuse existing styles

export default function CreatePassword() {
  const [email, setEmail] = useState("");
  const [token, setToken] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [message, setMessage] = useState("");
  const [step, setStep] = useState(1);
  const BACKEND_URL = process.env.REACT_APP_API_URL;

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const paramEmail = urlParams.get("email");
    const paramToken = urlParams.get("token");

    if (paramEmail) setEmail(paramEmail);
    if (paramToken) setToken(paramToken);
  }, []);

  const createPassword = async () => {
    if (!newPassword || !confirmPassword) {
      setMessage("Please enter a password.");
      return;
    }

    if (newPassword !== confirmPassword) {
      setMessage("Passwords do not match.");
      return;
    }

    try {
      await axios.post(`${BACKEND_URL}/agents/create-password`, {
        email,
        token,
        newPassword,
      });
      setMessage("Password created successfully!");
      setStep(2);
    } catch (err) {
      if (err.response && err.response.data && err.response.data.message) {
        setMessage(err.response.data.message);
      } else {
        setMessage("Error creating password.");
      }
    }
  };

  return (
    <div className="setpw-container">
      <div className="setpw-card">
        <h2 className="setpw-title">Create Password</h2>
        <p className="setpw-message">{message}</p>
        
        {step === 1 && (
          <>
            <p className="setpw-instruction">
              Your email has been verified. Please create a password for your account.
            </p>
            <input
              type="password"
              className="setpw-input"
              placeholder="New password"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
            />
            <input
              type="password"
              className="setpw-input"
              placeholder="Confirm password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
            />
            <button className="setpw-button" onClick={createPassword}>
              Create Password
            </button>
          </>
        )}

        {step === 2 && (
          <div className="setpw-success">
            <h3>Account ready!</h3>
            <a className="setpw-login-link" href="/login">Go to Login</a>
          </div>
        )}
      </div>
    </div>
  );
}
